import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControlLabel, Select } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { SelectChangeEvent } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import IsHighlight from "@warriortrading/warriortrading.hermes.common.feathers/enums/isHighlight";
import RoomStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/roomStatus";
import SiteSourceType from "@warriortrading/warriortrading.hermes.common.feathers/enums/siteSourceType";
import React, { useState } from "react";

export const RoomsList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc",
        },
      ],
    },
    pagination: {
      pageSize: 10,
    },
  });

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "name",
        headerName: "Name",
        minWidth: 150,
        flex: 1,
        hideable: false,
      },
      {
        field: "title",
        headerName: "Title",
        minWidth: 150,
        flex: 1,
        hideable: false,
      },
      {
        field: "status",
        headerName: "status",
        minWidth: 100,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          return RoomStatus.fromValue(row.status)?.name;
        },
      },
      {
        field: "vendor.name",
        headerName: "Vendor",
        minWidth: 100,
        flex: 1,
        hideable: false,
      },
      {
        field: "highlightQuestions",
        headerName: "HighlightQuestions",
        minWidth: 150,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          const isHighlight = row.highlightQuestions ? 0 : 1;
          return Object.values(IsHighlight)[0].find(
            (item: any) => item.value === isHighlight
          )?.name;
        },
      },
      {
        field: "sourceType",
        headerName: "RoomSourceType",
        minWidth: 150,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          return SiteSourceType.fromValue(row.sourceType)?.name;
        },
      },
      {
        field: "createdAt",
        headerName: "CreatedAt",
        minWidth: 160,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.createdAt) {
            return new Date(row.createdAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 160,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        minWidth: 100,
        align: "center",
        headerAlign: "center",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
            </>
          );
        },
      },
    ],
    []
  );

  // search parts
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState<any>("");
  const [roomSourceType, setRoomSourceType] = useState<any>("");

  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (id) {
      searchArr.push({
        field: "id",
        value: `${id}`,
        operator: "eq",
      });
    }
    if (name) {
      searchArr.push({
        field: "name[$ilike]",
        value: `%${name}%`,
        operator: "eq",
      });
    }
    if (title) {
      searchArr.push({
        field: "title[$ilike]",
        value: `%${title}%`,
        operator: "eq",
      });
    }
    if (status || status === 0) {
      searchArr.push({
        field: "status",
        value: `${status}`,
        operator: "eq",
      });
    }
    if (roomSourceType || roomSourceType === 0) {
      searchArr.push({
        field: "sourceType",
        value: `${roomSourceType}`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };
  const clearFun = () => {
    setId("");
    setName("");
    setTitle("");
    setStatus("");
    setRoomSourceType("");
    setFilters([]);
  };
  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Id"
                variant="standard"
                value={id}
                onChange={(e) => setId(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Name"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Title"
                variant="standard"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={{ width: "30%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <FormControl style={{ width: "30%" }}>
                <InputLabel id="status">Status : </InputLabel>
                <Select
                  labelId="status"
                  value={status as any}
                  label="Status"
                  variant="standard"
                  onChange={(event: SelectChangeEvent) => {
                    setStatus(event.target.value as any);
                  }}
                >
                  {Object.values(RoomStatus)[0].map((item: any) => {
                    return (
                      <MenuItem key={item.value} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl style={{ width: "30%" }}>
                <InputLabel id="roomSourceType">RoomSourceType : </InputLabel>
                <Select
                  labelId="roomSourceType"
                  value={roomSourceType as any}
                  label="RoomSourceType"
                  variant="standard"
                  onChange={(event: SelectChangeEvent) => {
                    setRoomSourceType(event.target.value as any);
                  }}
                >
                  {Object.values(SiteSourceType)[0].map((item: any) => {
                    return (
                      <MenuItem key={item.value} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <div style={{ width: "30%", paddingBottom: "7px" }}>
                <ClearOutlinedIcon onClick={clearFun} />
                <SearchIcon onClick={handleFilter} />
              </div>
            </div>
          </div>
        }
      />
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        paginationMode="server"
        rowsPerPageOptions={[10, 20, 50]}
        disableColumnFilter
      />
    </List>
  );
};
